import axios from "axios";

// const responseCamelCaseTransformer = (data) => {
//   if (data) {
//     if (Array.isArray(data)) {
//       return data.map((item) => responseCamelCaseTransformer(item));
//     }
//     const keys = Object.keys(data);
//     keys.forEach((key) => {
//       const newKey = key.charAt(0).toLowerCase() + key.slice(1);
//       if (typeof data[key] === "object" && data[key] !== null) {
//         data[newKey] = responseCamelCaseTransformer(data[key]);
//       } else {
//         data[newKey] = data[key];
//       }
//       if (newKey !== key) {
//         delete data[key];
//       }
//     });
//   }
//   return data;
// };

const axiosClient = axios.create({
  baseURL: "https://api.chs-biobank.org/api/",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.response.use(
  function (response) {
    const pagination = response.headers["x-pagination"];
    if (pagination) {
      response.pagination = JSON.parse(pagination);
    }
    return response;
  },
  function (error) {
    let res = error.response;

    return Promise.reject(error);
  }
);

axiosClient.interceptors.request.use(function (config) {
  config.headers.Authorization = "Bearer " + localStorage.getItem("auth_token");
  return config;
});

export default {
  axiosClient,
};
